import { useState } from "react";
import { Switch } from '@headlessui/react'
import { t } from "i18next";
import PropTypes from 'prop-types';

function ToggleSwitch({enabled,isEnabled ,disabled}) {

  const [toggled, setToggled] = useState(enabled ?? false)

  const onChange = () => {
    setToggled(!toggled);
    isEnabled(!toggled)
  }

  return (
    <div className={`flex items-center ${disabled && 'pointer-events-none'}`}>
      <Switch
        disabled={disabled}
        checked={toggled}
        onChange={onChange}
        className={`${toggled ? 'bg-blue-500' : 'bg-gray-300'}
          relative inline-flex flex-shrink-0 w-10 h-6 border-4 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        {/* <span className="sr-only bg-blue-500">Use setting</span> */}
        <span
          aria-hidden="true"
          className={`${toggled ? 'translate-x-4' : 'translate-x-0'}
            pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
        />
      </Switch>
      <span className={`text-xs font-semibold ml-2 w-12 ${toggled ? 'text-blue-500' : 'text-gray-500'}`}>{toggled ? t('actions.enabled') : t('actions.disabled') } </span>
    </div>
  )
}

ToggleSwitch.propTypes = {
  enabled: PropTypes.bool,
  isEnabled: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
